import './index.scss';

import * as Router from './assets/js/router';
import './assets/js/global';

Router.run();
